import Breadcrumb from '../../core/components/UI/Breadcrumb'
import { useMineralContext } from '../context/mineral/mineralProvider'
import { useCountryContext } from '../../core/context/country/CountryProvider'
import FormEditMineralCountry from '../components/mineral-country-edit/FormEditMineralCountry'
import useMineralCountryDetails from '../hooks/useMineralCountryDetails'
import LoaderEditMineralCountryForm from '../components/mineral-country-edit/LoaderEditMineralCountryForm'

export default function MineralCountryEditPage() {
  const { mineralState } = useMineralContext()
  const { countryState } = useCountryContext()

  const { details, isLoading } = useMineralCountryDetails()

  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المعادن',
            isActive: false,
            to: '/minerals',
          },
          {
            id: 2,
            label: mineralState.mineral?.name_ar,
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}`,
          },
          {
            id: 3,
            label: 'المناطق',
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}/countries`,
          },
          {
            id: 4,
            label: countryState.country?.name_ar,
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}/countries/${countryState.country?.id}`,
          },
          {
            id: 5,
            label: 'تعديل',
            isActive: true,
          },
        ]}
      />
      <div className="border-2 border-muted-500 bg-white p-2">
        {isLoading ? (
          <LoaderEditMineralCountryForm />
        ) : (
          <FormEditMineralCountry details={details} />
        )}
      </div>
    </>
  )
}
